import baseAPI from '@/http'

const router = 'api/usuario/grupo'

export const groupAPI = {
  create: (group) => baseAPI.post(router, group),
  update: (group) => baseAPI.put(router, group),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
